import { render } from "./PanelistSurveyAlternativePage.vue?vue&type=template&id=a8ec1370&ts=true"
import script from "./PanelistSurveyAlternativePage.vue?vue&type=script&lang=ts"
export * from "./PanelistSurveyAlternativePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__